import { IObservable, Subject } from '~/rage/utils';
import {
	Gender,
	IClientConfigs,
	IPedAppearanceValue,
	IPedFaceMorphValue,
	IPedParentsValue,
} from '~/shared';

export abstract class AbstractCharacterEditorService {
	protected parents = new Subject<IClientConfigs['appearance']['parents']>([]);
	protected faceMorphs = new Subject<
		IClientConfigs['appearance']['faceMorphs']
	>([]);

	public abstract setGenderValue(gender: Gender): Promise<void>;

	public getParentConfigs(): IObservable<
		IClientConfigs['appearance']['parents']
	> {
		return this.parents;
	}

	public abstract setParentsValue(parents: IPedParentsValue): Promise<void>;

	public getFaceMorphConfigs(): IObservable<
		IClientConfigs['appearance']['faceMorphs']
	> {
		return this.faceMorphs;
	}

	public abstract setFaceMorphValues(
		morphs: IPedFaceMorphValue[],
	): Promise<void>;

	public abstract setAppearanceValue(
		appearance: IPedAppearanceValue,
	): Promise<void>;

	public abstract exit(): Promise<void>;
}
